import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { HabSpacerComponent } from '../pages/hab/hab.page';
import { PipesModule } from '../pipes/pipes.module';
import { ButtonComponent } from './button/button.component';
import { CapsuleComponent } from './capsule/capsule.component';
import { ContentListCardComponent } from './content-list-item/content-list-card.component';
import { ContentListItemComponent } from './content-list-item/content-list-item.component';
import { ControlLabelComponent } from './control-label/control-label.component';
import { ControlMessagesComponent } from './control-messages/control-messages.component';
import { DateScrollComponent } from './date-scroll/date-scroll.component';
import { FilterDropdownComponent } from './filter-dropdown/filter-dropdown.component';
import { HealthAppAuthorizationComponent } from './health-app-authorization/health-app-authorization.component';
import { HeroBannerContentComponent } from './hero-banner/hero-banner-content/hero-banner-content.component';
import { HeroBannerTitleComponent } from './hero-banner/hero-banner-title/hero-banner-title.component';
import { HeroBannerComponent } from './hero-banner/hero-banner.component';
import { HeroListItemComponent } from './hero-banner/hero-list-item/hero-list-item.component';
import { ListCardItemComponent } from './list-card/list-card-item/list-card-item.component';
import { ListCardSubtitleComponent } from './list-card/list-card-subtitle/list-card-subtitle.component';
import { ListCardTitleComponent } from './list-card/list-card-title/list-card-title.component';
import { ListCardComponent } from './list-card/list-card.component';
import { LoaderComponent } from './loader/loader.component';
import { NavigationToolbarComponent } from './navigation-toolbar/navigation-toolbar.component';
import { SegmentButtonsComponent } from './segment-buttons/segment-buttons.component';
import { TelehealthComponent } from './telehealth/telehealth.component';
import { AppUpdateComponent } from './app-update/app-update.component';

@NgModule({
  declarations: [
    CapsuleComponent,
    ListCardComponent,
    ListCardSubtitleComponent,
    ListCardItemComponent,
    ListCardTitleComponent,
    NavigationToolbarComponent,
    HeroBannerComponent,
    HeroBannerTitleComponent,
    HeroBannerContentComponent,
    FilterDropdownComponent,
    DateScrollComponent,
    SegmentButtonsComponent,
    ButtonComponent,
    ControlLabelComponent,
    HabSpacerComponent,
    ContentListItemComponent,
    LoaderComponent,
    ControlMessagesComponent,
    HealthAppAuthorizationComponent,
    HeroListItemComponent,
    ContentListCardComponent,
    TelehealthComponent,
    AppUpdateComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    IonicModule.forRoot({
      swipeBackEnabled: false,
    }),
    ReactiveFormsModule,
  ],
  exports: [
    CapsuleComponent,
    ListCardComponent,
    ListCardSubtitleComponent,
    ListCardItemComponent,
    ListCardTitleComponent,
    NavigationToolbarComponent,
    HeroBannerComponent,
    HeroBannerTitleComponent,
    HeroBannerContentComponent,
    FilterDropdownComponent,
    DateScrollComponent,
    SegmentButtonsComponent,
    ButtonComponent,
    ControlLabelComponent,
    HabSpacerComponent,
    ContentListItemComponent,
    LoaderComponent,
    ControlMessagesComponent,
    HealthAppAuthorizationComponent,
    HeroListItemComponent,
    ContentListCardComponent,
    TelehealthComponent,
    AppUpdateComponent,
  ]
})
export class UIComponentsModule { }
